var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagsProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66732 18.3307V16.6641M5.91732 12.4974V5.83073M11.334 18.3307V16.6641M10.084 12.4974V5.83073M5.33398 16.6641H10.6673C12.0674 16.6641 12.7675 16.6641 13.3023 16.3916C13.7727 16.1519 14.1552 15.7694 14.3948 15.299C14.6673 14.7643 14.6673 14.0642 14.6673 12.6641V5.66406C14.6673 4.26393 14.6673 3.56387 14.3948 3.02909C14.1552 2.55868 13.7727 2.17623 13.3023 1.93655C12.7675 1.66406 12.0674 1.66406 10.6673 1.66406H5.33398C3.93385 1.66406 3.23379 1.66406 2.69901 1.93655C2.2286 2.17623 1.84615 2.55868 1.60647 3.02909C1.33398 3.56387 1.33398 4.26393 1.33398 5.66406V12.6641C1.33398 14.0642 1.33398 14.7643 1.60647 15.299C1.84615 15.7694 2.2286 16.1519 2.69901 16.3916C3.23379 16.6641 3.93385 16.6641 5.33398 16.6641Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsProduct);
export default __webpack_public_path__ + "static/media/tags-product.36f33bb947c95f4c429f8cdd292de571.svg";
export { ForwardRef as ReactComponent };